import React from 'react'

import ReactSVG from 'react-svg'
import {Avatar, withStyles} from 'material-ui'

import playButton from './svg/essential-compilation/play-button.svg'


const styles = theme => ({
    videoAvatar: {
        margin: 10,
        width: "3.2em",
        height: "3.2em",
        backgroundColor: 'transparent',
        display: 'flex',
        cursor: 'pointer',
        border: "4px solid white;"

    },
    videoAvatarIcon: {
        fill: 'white',
        width: 24,
        height: 24,
        marginLeft: 4,
    },
})

export const PlayButton =({classes, onClick}) => (
    <Avatar className={classes.videoAvatar} onClick={onClick}>
        <ReactSVG wrapperClassName={classes.videoAvatarIcon} path={playButton}/>
    </Avatar>
)

export default withStyles(styles)(PlayButton)




// WEBPACK FOOTER //
// ./src/components/PlayButton.jsx